import { computed } from 'vue'

import { useCookie } from '@/composables/useCookie'
import { DELIVERY_COOKIE } from '@/constants/storage'
import { t } from '@/i18n'

/** Тип получения: 0 — доставка, 200 — самовывоз (§4 LOGIC.md). */
export const ORDER_TYPE = { delivery: 0, pickup: 200 } as const

export type OrderType = (typeof ORDER_TYPE)[keyof typeof ORDER_TYPE]

export interface DeliveryOption {
  value: OrderType
  label: string
}

/* Функция, а не константа: подписи должны меняться вместе с языком */
export const deliveryOptions = (): DeliveryOption[] => [
  { value: ORDER_TYPE.delivery, label: t('delivery.delivery') },
  { value: ORDER_TYPE.pickup, label: t('delivery.pickup') },
]

/** Тип получения живёт в cookie: его читает и прокси, и бэкенд меню. */
export function useDelivery() {
  const delivery = useCookie(DELIVERY_COOKIE, { default: String(ORDER_TYPE.delivery) })

  const activeDelivery = computed<OrderType>(() =>
    Number(delivery.value) === ORDER_TYPE.pickup ? ORDER_TYPE.pickup : ORDER_TYPE.delivery,
  )

  const isDelivery = computed(() => activeDelivery.value === ORDER_TYPE.delivery)

  function setActiveDelivery(value: OrderType): void {
    delivery.value = String(value)
  }

  return { activeDelivery, isDelivery, deliveryOptions, setActiveDelivery }
}
